<template>
    <v-app>
        <v-main class="page-main">
            <v-container class="fill-height" fluid>
                <slot />
            </v-container>
            <v-footer padless absolute height="50">
                <v-col class="text-center" cols="12">
                    <span class="text-caption grey--text"> © Pappyon Pty Ltd {{ new Date().getFullYear() }}</span>
                    <a class="text-caption grey--text mx-8 text-decoration-none"
                        href="https://pappyon.com/contact/">Contact</a>
                    <a class="text-caption grey--text text-decoration-none" href="https://pappyon.com/terms-of-use/">Privacy
                        & Terms</a>
                </v-col>
            </v-footer>

        </v-main>
</v-app>
</template>
<script>
export default {
}
</script>
<style scoped>
.page-main{
    background-color: white;
}

</style>